import { render, staticRenderFns } from "./PopupShopingListEmail.vue?vue&type=template&id=287d78cf"
import script from "./PopupShopingListEmail.vue?vue&type=script&lang=js"
export * from "./PopupShopingListEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports